"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class History {
    constructor(historyApi, cache, calorieBudgetUtils, mutableLocale) {
        this.historyApi = historyApi;
        this.cache = cache;
        this.calorieBudgetUtils = calorieBudgetUtils;
        this.mutableLocale = mutableLocale;
        this.getHistory = async (memberId, unit) => {
            const getRequest = async (prev) => {
                var _a;
                const items = await this.historyApi.getHistory(memberId);
                const prevItems = (_a = prev === null || prev === void 0 ? void 0 : prev.items) !== null && _a !== void 0 ? _a : [];
                const map = new Map();
                items.items.concat(prevItems).forEach((item) => {
                    map.set(item.id, item);
                });
                return {
                    items: Array.from(map.values()),
                };
            };
            const shouldRefresh = () => Promise.resolve(true);
            try {
                const response = await this.cache.get(this.getKey(memberId), shouldRefresh, getRequest);
                const items = response.items.slice(0, 10);
                if (unit === "oz") {
                    return {
                        items: this.recalculateBudgetToOz(items),
                    };
                }
                return {
                    items,
                };
            }
            catch (e) {
                if (e instanceof exception_1.NetworkException) {
                    return {
                        items: [],
                    };
                }
                throw e;
            }
        };
        this.getHistoryAfter = async (memberId, afterEventId, unit) => {
            const getRequest = async (prev) => {
                var _a;
                const items = await this.historyApi.getHistoryAfter(memberId, afterEventId);
                const prevItems = (_a = prev === null || prev === void 0 ? void 0 : prev.items) !== null && _a !== void 0 ? _a : [];
                const map = new Map();
                prevItems.concat(items.items).forEach((item) => {
                    map.set(item.id, item);
                });
                return {
                    items: Array.from(map.values()),
                };
            };
            const shouldRefresh = async (prevItems) => {
                return (!prevItems ||
                    !prevItems.items.length ||
                    prevItems.items[prevItems.items.length - 1].id === afterEventId);
            };
            try {
                const response = await this.cache.get(this.getKey(memberId), shouldRefresh, getRequest);
                const afterEventIndex = response.items.findIndex((item) => item.id === afterEventId);
                const items = response.items.slice(afterEventIndex + 1, afterEventIndex + 11);
                if (unit === "oz") {
                    return {
                        items: this.recalculateBudgetToOz(items),
                    };
                }
                return {
                    items,
                };
            }
            catch (e) {
                if (e instanceof exception_1.NetworkException) {
                    return {
                        items: [],
                    };
                }
                throw e;
            }
        };
        this.getKey = (memberId) => `history.${memberId}.${this.mutableLocale.toString()}`;
        this.recalculateBudgetToOz = (historyItems) => {
            return historyItems.map((item) => {
                if ("nextBudget" in item) {
                    return {
                        ...item,
                        prevBudget: item.prevBudget &&
                            this.calorieBudgetUtils.recalculateCalorieBudgetToOz(item.prevBudget),
                        nextBudget: this.calorieBudgetUtils.recalculateCalorieBudgetToOz(item.nextBudget),
                    };
                }
                return item;
            });
        };
    }
}
exports.default = History;
//# sourceMappingURL=History.js.map